module.exports = __webpack_public_path__ + "static/media/fk_logo.56583bdb.png";